export interface MenuItem {
  id: string;
  name: string;
  /** i18n translation key resolved at render time. Falls back to `name` when missing. */
  nameKey?: string;
  link?: string;
  icon?: string;
  subMenu?: MenuItem[];
  requiredPermissions?: string[];
  showInMobile?: boolean;
}

export type MenuItemWithAccessControl = MenuItem & {
  isVisible: (userRoles: string[]) => boolean;
};

export const withRolesCheck = (menuItem: MenuItem, roles: string[]): MenuItemWithAccessControl => ({
  ...menuItem,
  isVisible(userRoles: string[]) {
    return roles.every(role => userRoles.includes(role));
  },
});

export const withAllowAny = (menuItem: MenuItem): MenuItemWithAccessControl => ({
  ...menuItem,
  isVisible(_: string[]) {
    return true;
  },
});

export const menuItems: MenuItemWithAccessControl[] = [
  withAllowAny({
    id: '1',
    name: 'Επισκόπηση',
    nameKey: 'menu.overview',
    link: '/dashboard',
    icon: 'HomeOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '2',
    name: 'Επαφές',
    nameKey: 'menu.contacts',
    link: `/contacts`,
    icon: 'BookOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '2a',
    name: 'Leads',
    nameKey: 'menu.leads',
    link: `/leads`,
    icon: 'PeopleAltOutlined',
    requiredPermissions: ['leads:read'],
  }),
  withAllowAny({
    id: '3',
    name: 'Εταιρείες',
    nameKey: 'menu.companies',
    link: `/companies`,
    icon: 'BusinessOutlined',
    requiredPermissions: ['companies:read'],
    showInMobile: true,
  }),
  withAllowAny({
    id: '4',
    name: 'Παραγγελίες',
    nameKey: 'menu.orders',
    link: `/orders`,
    icon: 'ReceiptLongOutlined',
  }),
  withAllowAny({
    id: '5',
    name: 'Υπάλληλοι',
    nameKey: 'menu.employees',
    link: `/employees`,
    icon: 'BadgeOutlined',
  }),
  withAllowAny({
    id: '5a',
    name: 'Κάρτα Εργασίας',
    nameKey: 'menu.workCard',
    link: `/work-card`,
    icon: 'QrCodeScannerOutlined',
    requiredPermissions: ['ergani:access'],
    showInMobile: true,
  }),
  withAllowAny({
    id: '6',
    name: 'Ημερολόγιο',
    nameKey: 'menu.bookings',
    link: `/bookings`,
    icon: 'CalendarMonthOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '7',
    name: 'Υπηρεσίες',
    nameKey: 'menu.services',
    link: `/services`,
    icon: 'RoomServiceOutlined',
    showInMobile: true,
  }),
  withAllowAny({
    id: '7a',
    name: 'Στατιστικά',
    nameKey: 'menu.statistics',
    link: `/statistics`,
    icon: 'AssessmentOutlined',
    requiredPermissions: ['statistics:read'],
    showInMobile: true,
  }),
  withAllowAny({
    id: '8',
    name: 'Ρυθμίσεις',
    nameKey: 'menu.settings',
    link: `/settings`,
    icon: 'SettingsOutlined',
  }),
];
